module.exports = __webpack_public_path__ + "static/img/saimenInstallForMac_pic8.7eba77d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForMac/saimenInstallForMac_pic8.png
// module id = 574
// module chunks = 1